import FlashIcon from 'assets/Icons/FlashIcon';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  offerText: string;
  className?: string;
}

const OfferText: FC<Props> = ({ offerText, className }) => {
  return (
    <div className={twMerge('flex flex-col gap-1', className)}>
      <div className='flex items-center'>
        <FlashIcon className='sm:min-w-[39px] min-w-[32px]  w-[32px] sm:w-[39px]   z-20 -mr-[24px] -mb-[10px]' />
        <div className='sm:py-1.5 py-0.5 sm:pe-2 pe-1.5 sm:ps-5 ps-[20px] bg-grayZl-900 rounded-r-full'>
          <p className='sm:text-base/6 text-xs/6 font-semibold text-white'>
            {offerText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfferText;
